export default __webpack_public_path__ + "static/media/hero1.52c0f073.m4v";